export enum OrderSelectionType {
    SINGLE = "single",
    MULTIPLE = "multiple"
}

export enum EditType {
    DEFAULT = "default",
    ROUTE_NULL = "route_null",
    DATE_NULL = "date_null",
    BOTH_NULL = "both_null"
}
  
  